'use client'
import React, { useState } from "react";
import dynamic from 'next/dynamic';

const Gallery = dynamic(() => import('@components/Gallery'), {
    ssr: false,
});

const PropertyFloorplansGallery = ({ gallery, altName = '', dictionary }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPopupOpen, setPopupOpen] = useState(false);

    if (!gallery || gallery.length === 0) return null;

    const openPopup = (index) => {
        setActiveSlide(index);
        setPopupOpen(true);
    };

    const closePopup = () => setPopupOpen(false);

    return (
        <>
            <div className="sm:px-0 px-2">
                <button
                    className="mt-2 py-1 px-2 border border-third rounded-md text-third font-bold"
                    onClick={() => openPopup(0)}
                    onMouseEnter={() => import('@components/Gallery')} // preload
                >
                    {dictionary.floorPlans} ({gallery.length})
                </button>
            </div>

            {isPopupOpen && (
                <Gallery
                    isOpen={isPopupOpen}
                    onClose={closePopup}
                    gallery={gallery}
                    initialSlide={activeSlide}
                    altName={altName}
                />
            )}
        </>
    );
}

export default PropertyFloorplansGallery;
